import React from 'react'

import './styles.scss'

import backgroundImg from './img/background.jpg'
import separatorImg from './img/separator.png'

import { IntroProps } from '../types'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

const Intro = ({
  coupleData: { weddingDate, coupleSimplifiedName },
  buttonMessage,
  warningMessage,
  locale = 'pt-BR',
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  const date = new Intl.DateTimeFormat(locale).format(
    new Date(weddingDate.timestamp)
  )

  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro243">
      <div className="intro243desktop screen">
        <img src={background || backgroundImg} className="mainbackground" />
        <div className="mask-C61RwL"></div>
        <div className="container-center-horizontal">
          <div className="button-C61RwL">
            <div
              className="site-de-casamento-e-xHxYv9"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <div className="button-xHxYv9" role="button" onClick={onSkipIntro}>
              <div className="pular-introduo-kA8htT">{buttonMessage}</div>
            </div>
          </div>
        </div>
        <div className="container-center-vertical container-center-horizontal">
          <div className="content-C61RwL">
            <div className="stacked-group-xUsx1L">
              <div className="notranslate ah1-6En43k valign-text-middle bp1-intro243-animate-enter1">
                {coupleSimplifiedName.bride}
              </div>
              <div
                style={!coupleSimplifiedName.groom ? { display: 'none' } : {}}
                className="x-6En43k bp1-intro243-animate-enter2"
              >
                <div className="rectangle-O9ojRB"></div>
                <img className="fill-1-O9ojRB" src={separatorImg} />
                <div className="rectangle-NvEjQJ"></div>
              </div>
              {!!coupleSimplifiedName.groom && (
                <div className="notranslate ah1-E3JrGL valign-text-middle bp1-intro243-animate-enter3">
                  {coupleSimplifiedName.groom}
                </div>
              )}
            </div>
            <div className="daymonthyear-xUsx1L titlesmdarkmobile bp1-intro243-animate-enter">
              {date}
            </div>
          </div>
        </div>
      </div>
      <div className="intro243mobile screen">
        <img src={background || backgroundImg} className="mainbackground" />
        <div className="mask-C61RwL"></div>
        <div className="container-center-horizontal">
          <div className="button-C61RwL">
            <div
              className="site-de-casamento-e-xHxYv9"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <div className="button-xHxYv9" role="button" onClick={onSkipIntro}>
              <div className="pular-introduo-kA8htT">{buttonMessage}</div>
            </div>
          </div>
        </div>
        <div className="container-center-vertical container-center-horizontal">
          <div className="content-C61RwL">
            <div className="stacked-group-xUsx1L">
              <div className="notranslate ah1-6En43k valign-text-middle bp2-intro243-animate-enter1">
                {coupleSimplifiedName.bride}
              </div>
              <div
                style={!coupleSimplifiedName.groom ? { display: 'none' } : {}}
                className="x-6En43k bp2-intro243-animate-enter2"
              >
                <div className="rectangle-O9ojRB"></div>
                <img className="fill-1-O9ojRB" src={separatorImg} />
                <div className="rectangle-NvEjQJ"></div>
              </div>
              {!!coupleSimplifiedName.groom && (
                <div className="notranslatem ah1-E3JrGL valign-text-middle bp2-intro243-animate-enter3">
                  {coupleSimplifiedName.groom}
                </div>
              )}
            </div>
            <div className="daymonthyear-xUsx1L bp2-intro243-animate-enter">
              {date}
            </div>
          </div>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
